/**
 * 键盘按键码常量表，数值为 KeyboardEvent.keyCode 对应值，字母键通过 charCodeAt 计算。
 */
export const KeyCodes = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  BOTTOM: 40,
  DELETE: 46,
  ESC: 27,
  ENTER: 13,
  CTRL: 17,
  SHIFT: 16,

  A: 'A'.charCodeAt(0),
  S: 'S'.charCodeAt(0),
  D: 'D'.charCodeAt(0),
  W: 'W'.charCodeAt(0),
  Q: 'Q'.charCodeAt(0),
  E: 'E'.charCodeAt(0),
  R: 'R'.charCodeAt(0),
  F: 'F'.charCodeAt(0),
  Z: 'Z'.charCodeAt(0),
  Y: 'Y'.charCodeAt(0),
}
